module.exports = __webpack_public_path__ + "static/media/logo_dark.3f64d5d1.png";